var t, i;
function a() {
  if (i) return t;
  i = 1;
  function s() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return t = s, t;
}
export {
  a as __require
};
//# sourceMappingURL=zstream.es.js.map
